import { render, staticRenderFns } from "./transferOrderLabel.vue?vue&type=template&id=786a8c8d&scoped=true&"
import script from "./transferOrderLabel.vue?vue&type=script&lang=js&"
export * from "./transferOrderLabel.vue?vue&type=script&lang=js&"
import style0 from "./transferOrderLabel.vue?vue&type=style&index=0&id=786a8c8d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786a8c8d",
  null
  
)

export default component.exports